import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  key: 0,
  class: "title mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "title mb-0"
}
const _hoisted_6 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_7 = { "aria-label": "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb mb-0" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_12 = {
  key: 1,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_13 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "text-md-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "card"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-8" }
const _hoisted_21 = { class: "inline-items align-middle" }
const _hoisted_22 = { for: "" }
const _hoisted_23 = { class: "table-responsive my-3 font-12" }
const _hoisted_24 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_25 = { class: "table-primary nowrap-text" }
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { scope: "col" }
const _hoisted_28 = { scope: "col" }
const _hoisted_29 = { scope: "col" }
const _hoisted_30 = { scope: "col" }
const _hoisted_31 = { scope: "col" }
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { scope: "col" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "dropdown-menu table-dropdown items-dropdown-menu" }
const _hoisted_39 = { class: "form-group control-with-icon" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search" })
], -1)
const _hoisted_41 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_43 = {
  key: 1,
  ref: "table"
}
const _hoisted_44 = { class: "text-right p-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_46 = { class: "dropdown-wrap unit-dropdown position-relative" }
const _hoisted_47 = { class: "mr-3" }
const _hoisted_48 = { class: "dropdown-menu custom-scroll table-dropdown" }
const _hoisted_49 = { class: "dropdown-actions" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = { class: "control-wrap" }
const _hoisted_54 = { class: "dropdown-wrap position-relative" }
const _hoisted_55 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_56 = { class: "mr-3" }
const _hoisted_57 = { class: "dropdown-menu with-badge-list" }
const _hoisted_58 = { class: "text-nowrap" }
const _hoisted_59 = { class: "item-desc" }
const _hoisted_60 = { class: "text-nowrap" }
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_64 = { class: "modal-wrap default-modal" }
const _hoisted_65 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = { class: "form-group with-mic-btns" }
const _hoisted_71 = { for: "" }
const _hoisted_72 = { class: "absolute-mic-wrap" }
const _hoisted_73 = { class: "modal-footer" }
const _hoisted_74 = {
  type: "button",
  class: "btn default-btn",
  "data-dismiss": "modal"
}
const _hoisted_75 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_76 = { class: "shadow-none" }
const _hoisted_77 = {
  colspan: 8,
  class: "text-right"
}
const _hoisted_78 = { colspan: 3 }
const _hoisted_79 = { class: "form-group text-right" }
const _hoisted_80 = {
  key: 0,
  class: "error-field-text"
}
const _hoisted_81 = { class: "modal-wrap default-modal" }
const _hoisted_82 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_83 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_84 = { class: "modal-content" }
const _hoisted_85 = { class: "modal-header" }
const _hoisted_86 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_87 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "form-group" }
const _hoisted_91 = { for: "" }
const _hoisted_92 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_93 = { class: "form-group" }
const _hoisted_94 = { for: "" }
const _hoisted_95 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_96 = { class: "modal-footer" }
const _hoisted_97 = { class: "modal-wrap default-modal" }
const _hoisted_98 = {
  class: "modal fade",
  id: "deleteItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_99 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_100 = { class: "modal-content" }
const _hoisted_101 = { class: "modal-header" }
const _hoisted_102 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_103 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_104 = { class: "modal-body" }
const _hoisted_105 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_106 = { class: "text-danger" }
const _hoisted_107 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceInputField = _resolveComponent("PriceInputField")
  const _component_VoiceToText = _resolveComponent("VoiceToText")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_CreateLineItemInJobEstimation = _resolveComponent("CreateLineItemInJobEstimation")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.state.ui.isLoading.isEdit)
            ? (_openBlock(), _createBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t('edit_job_estimation')), 1))
            : (_openBlock(), _createBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('create_job_estimation')), 1)),
          _createVNode("div", _hoisted_6, [
            _createVNode("nav", _hoisted_7, [
              _createVNode("ol", _hoisted_8, [
                _hoisted_9,
                (_ctx.state.ui.isLoading.isEdit)
                  ? (_openBlock(), _createBlock("li", _hoisted_10, [
                      _createVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('edit_job_estimation')), 1)
                    ]))
                  : (_openBlock(), _createBlock("li", _hoisted_12, [
                      _createVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('create_job_estimation')), 1)
                    ]))
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
            }, _toDisplayString(_ctx.$t('create_line_item')), 1),
            (_ctx.state.ui.isLoading.addNewSubItem)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
                }, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ]))
              : (_openBlock(), _createBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoJobEstimation && _ctx.gotoJobEstimation(...args)))
                }, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ]))
          ])
        ])
      ])
    ]),
    (!_ctx.state.ui.isLoading.addNewSubItem)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('title')) + " :", 1)
                  ]),
                  _createVNode("li", null, [
                    _withDirectives(_createVNode("textarea", {
                      id: "title",
                      class: _ctx.state.ui.errors.titleError ? 'form-control error-field' : 'form-control',
                      name: "title",
                      rows: 2,
                      cols: 50,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.title = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.state.data.title]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("table", _hoisted_24, [
              _createVNode("thead", _hoisted_25, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('item')), 1),
                  _createVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('description')), 1),
                  _createVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('qty')), 1),
                  _createVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('unit')), 1),
                  _createVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('cost')), 1),
                  _createVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('sub_total')), 1),
                  _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('markup')), 1),
                  _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('set_allowance')), 1),
                  _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('allowance')), 1),
                  _createVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('total')), 1),
                  _createVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('action')), 1)
                ])
              ]),
              (!_ctx.state.cloningSelectedItem)
                ? (_openBlock(), _createBlock("tbody", _hoisted_37, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: selectedItemIndex }, [
                        _createVNode("td", null, [
                          _createVNode("div", {
                            class: `dropdown-wrap unit-dropdown position-relative items-dropdown job-item-dropdown${selectedItemIndex}`
                          }, [
                            (selectedItem.parent_id)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  class: "dropdown-toggle d-block border rounded py-2 px-3",
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false",
                                  onClick: ($event: any) => (_ctx.onToggleChooseItem(selectedItemIndex))
                                }, _toDisplayString(selectedItem.name ? selectedItem.mainName + ':' + selectedItem.name :
                                                'ChooseItem'), 9, ["onClick"]))
                              : (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  class: "dropdown-toggle d-block border rounded py-2 px-3",
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false",
                                  onClick: ($event: any) => (_ctx.onToggleChooseItem(selectedItemIndex))
                                }, _toDisplayString(selectedItem.name ? selectedItem.name : _ctx.$t('choose_item')), 9, ["onClick"])),
                            _createVNode("div", _hoisted_38, [
                              _createVNode("a", {
                                class: "dropdown-item border-bottom text-success",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.addNewSubItem(selectedItemIndex))
                              }, "+ " + _toDisplayString(_ctx.$t('add_new_item')), 9, ["onClick"]),
                              _createVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.searchName = $event)),
                                  class: "form-control w-100",
                                  placeholder: _ctx.$t('enter_to_search'),
                                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
                                }, null, 40, ["placeholder"]), [
                                  [_vModelText, _ctx.state.data.searchName]
                                ])
                              ]),
                              (_ctx.state.ui.isLoading.getData)
                                ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                    _hoisted_42
                                  ]))
                                : _createCommentVNode("", true),
                              (selectedItem.tableSelected)
                                ? (_openBlock(), _createBlock("div", _hoisted_43, null, 512))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_44, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn default-btn btn-sm jobitem-btn",
                                  onClick: ($event: any) => (_ctx.closeSelected(selectedItemIndex))
                                }, [
                                  _hoisted_45,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('ok')), 1)
                                ], 8, ["onClick"])
                              ])
                            ])
                          ], 2)
                        ]),
                        _createVNode("td", null, [
                          _withDirectives(_createVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                            rows: 5,
                            onClick: ($event: any) => (_ctx.showAddDetails(selectedItemIndex)),
                            disabled: selectedItem.id == 0
                          }, null, 8, ["onUpdate:modelValue", "onClick", "disabled"]), [
                            [_vModelText, selectedItem.description]
                          ])
                        ]),
                        _createVNode("td", null, [
                          _withDirectives(_createVNode("input", {
                            type: "number",
                            class: selectedItem.quantityError ? 'form-control error-field' : 'form-control',
                            "onUpdate:modelValue": ($event: any) => (selectedItem.quantity = $event),
                            onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                          }, null, 42, ["onUpdate:modelValue", "onKeyup"]), [
                            [_vModelText, selectedItem.quantity]
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_46, [
                            _createVNode("a", {
                              class: selectedItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createVNode("span", _hoisted_47, _toDisplayString(selectedItem.unit ?
                                                selectedItem.unit.name : _ctx.$t('select_unit')), 1)
                            ], 2),
                            _createVNode("div", _hoisted_48, [
                              _createVNode("a", {
                                class: "dropdown-item border-bottom text-success",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.addNewUnit(selectedItem))
                              }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                return (_openBlock(), _createBlock("a", {
                                  class: "dropdown-item with-actions",
                                  href: "javascript:void(0)",
                                  key: unitIndex
                                }, [
                                  _createVNode("span", {
                                    class: "unit-title d-block",
                                    onClick: ($event: any) => (_ctx.changeUnit(selectedItemIndex, unit))
                                  }, _toDisplayString(unit.name), 9, ["onClick"]),
                                  _createVNode("span", _hoisted_49, [
                                    _createVNode("span", {
                                      class: "actions-text",
                                      onClick: ($event: any) => (_ctx.editUnit(unit))
                                    }, [
                                      _hoisted_50
                                    ], 8, ["onClick"]),
                                    _createVNode("span", {
                                      class: "actions-text ml-2",
                                      onClick: ($event: any) => (_ctx.deleteUnit(selectedItem, unit))
                                    }, [
                                      _hoisted_51
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createVNode("td", null, [
                          (selectedItem.cost)
                            ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                key: 0,
                                parentClass: selectedItem.costError ? 'form-control error-field' : 'form-control',
                                price: selectedItem.cost,
                                onUpdateItem: ($event: any) => (_ctx.updateItem(selectedItemIndex, $event)),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                              }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup"]))
                            : _withDirectives((_openBlock(), _createBlock("input", {
                                key: 1,
                                type: "text",
                                class: selectedItem.costError ? 'form-control error-field' : 'form-control',
                                "onUpdate:modelValue": ($event: any) => (selectedItem.cost = $event),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                              }, null, 42, ["onUpdate:modelValue", "onKeyup"])), [
                                [_vModelText, selectedItem.cost]
                              ])
                        ]),
                        _createVNode("td", null, _toDisplayString(_ctx.usdPriceFormate(selectedItem.subTotal ? selectedItem.subTotal : 0)), 1),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_52, [
                            _createVNode("div", _hoisted_53, [
                              (selectedItem.markup_type == 0)
                                ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                    key: 0,
                                    parentClass: 'form-control',
                                    price: selectedItem.markup,
                                    onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(selectedItemIndex, $event)),
                                    onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                  }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                                : _createCommentVNode("", true),
                              (selectedItem.markup_type == 1)
                                ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                    key: 1,
                                    parentClass: 'form-control',
                                    price: selectedItem.markup,
                                    from: _ctx.state.data.inputFrom,
                                    onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(selectedItemIndex, $event)),
                                    onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                  }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_54, [
                              _createVNode("a", _hoisted_55, [
                                _createVNode("span", _hoisted_56, _toDisplayString(selectedItem.markup_type == 0 ?
                                                    '$' : '%'), 1)
                              ]),
                              _createVNode("div", _hoisted_57, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 0))
                                    }, "$ ", 8, ["onClick"]),
                                    (_ctx.defMarkUpType != 0)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateMarkupType(0)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 1))
                                    }, "%", 8, ["onClick"]),
                                    (_ctx.defMarkUpType != 1)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateMarkupType(1)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode("input", {
                            type: "checkbox",
                            checked: selectedItem.isAllowance,
                            onChange: ($event: any) => (_ctx.handleCheckboxChange(selectedItem, selectedItemIndex, $event))
                          }, null, 40, ["checked", "onChange"])
                        ]),
                        _createVNode("td", null, [
                          _createVNode(_component_PriceInputField, {
                            parentClass: 'form-control',
                            price: selectedItem.allowance,
                            onUpdateItem: ($event: any) => (_ctx.updateItemAllowance(selectedItemIndex, $event))
                          }, null, 8, ["price", "onUpdateItem"])
                        ]),
                        _createVNode("td", _hoisted_58, [
                          _createVNode("div", _hoisted_59, _toDisplayString(_ctx.usdPriceFormate(selectedItem.total ? selectedItem.total : 0)), 1)
                        ]),
                        _createVNode("td", _hoisted_60, [
                          (Object.keys(selectedItem).length === 0 || selectedItemIndex == _ctx.state.selectItems.length - 1)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn enable-btn mr-1",
                                onClick: ($event: any) => (_ctx.addMoreSubItems(selectedItem)),
                                title: _ctx.$t('add')
                              }, [
                                _hoisted_61,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                              ], 8, ["onClick", "title"]))
                            : _createCommentVNode("", true),
                          (_ctx.state.selectItems.length != 1)
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                href: "javascript:void(0)",
                                class: "btn btn-info mr-1",
                                onClick: ($event: any) => (_ctx.cloneItem(selectedItemIndex, selectedItem)),
                                title: _ctx.$t('copy')
                              }, [
                                _hoisted_62,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('copy')), 1)
                              ], 8, ["onClick", "title"]))
                            : _createCommentVNode("", true),
                          (_ctx.state.selectItems.length != 1)
                            ? (_openBlock(), _createBlock("a", {
                                key: 2,
                                href: "javascript:void(0)",
                                class: "btn delete-btn",
                                onClick: ($event: any) => (_ctx.deleteItemShow(selectedItem)),
                                title: _ctx.$t('remove')
                              }, [
                                _hoisted_63,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick", "title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_64, [
                          _createVNode("div", {
                            class: "modal fade",
                            id: 'addDetails' + selectedItemIndex,
                            tabindex: -1,
                            "aria-labelledby": "addDetails",
                            "aria-hidden": "true"
                          }, [
                            _createVNode("div", _hoisted_65, [
                              _createVNode("div", _hoisted_66, [
                                _createVNode("div", _hoisted_67, [
                                  _createVNode("h5", {
                                    class: "modal-title",
                                    id: 'addDetails' + selectedItemIndex
                                  }, _toDisplayString(_ctx.$t('add_details')), 9, ["id"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: "close",
                                    "data-dismiss": "modal",
                                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                                    "aria-label": "Close"
                                  }, [
                                    _hoisted_68
                                  ])
                                ]),
                                _createVNode("div", _hoisted_69, [
                                  _createVNode("div", _hoisted_70, [
                                    _createVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('description')), 1),
                                    _withDirectives(_createVNode("textarea", {
                                      class: "form-control",
                                      "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                                      rows: 20,
                                      cols: 60
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, selectedItem.description]
                                    ]),
                                    _createVNode("div", _hoisted_72, [
                                      _createVNode(_component_VoiceToText, {
                                        onStartRecording: ($event: any) => (_ctx.startRecording(selectedItemIndex, $event))
                                      }, null, 8, ["onStartRecording"])
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_73, [
                                  _createVNode("button", _hoisted_74, _toDisplayString(_ctx.$t('save')), 1),
                                  _createVNode("button", _hoisted_75, _toDisplayString(_ctx.$t('cancel')), 1)
                                ])
                              ])
                            ])
                          ], 8, ["id"])
                        ])
                      ]))
                    }), 128)),
                    _createVNode("tr", _hoisted_76, [
                      _createVNode("td", _hoisted_77, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('total')), 1)
                        ])
                      ]),
                      _createVNode("td", _hoisted_78, [
                        _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.totalMarkUP)), 1),
                        _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_79, [
            (_ctx.state.ui.errors.hasError)
              ? (_openBlock(), _createBlock("p", _hoisted_80, _toDisplayString(_ctx.$t('input_field_required')) + ".", 1))
              : _createCommentVNode("", true),
            (_ctx.state.ui.isLoading.isEdit)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateJobEstimation && _ctx.updateJobEstimation(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.$t('save')), 9, ["disabled"]))
              : (_openBlock(), _createBlock("button", {
                  key: 2,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.creatJobEstimation && _ctx.creatJobEstimation(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.state.ui.isPostLoading.createJobEstimation ?
                            _ctx.$t('loading1') : _ctx.$t('save')), 9, ["disabled"])),
            (_ctx.state.ui.isLoading.isEdit)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation,
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveSend && _ctx.saveSend(...args)))
                }, _toDisplayString(_ctx.$t('save_and_send')), 9, ["disabled"]))
              : (_openBlock(), _createBlock("button", {
                  key: 4,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveSend && _ctx.saveSend(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.$t('save_and_send')), 9, ["disabled"])),
            _createVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearAllJobItem && _ctx.clearAllJobItem(...args)))
            }, _toDisplayString(_ctx.$t('clear')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_81, [
      _createVNode("div", _hoisted_82, [
        _createVNode("div", _hoisted_83, [
          _createVNode("div", _hoisted_84, [
            _createVNode("div", _hoisted_85, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_86, _toDisplayString(_ctx.$t('update')) + " " + _toDisplayString(_ctx.$t('unit')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_87, _toDisplayString(_ctx.$t('add_unit')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_88
              ])
            ]),
            _createVNode("div", _hoisted_89, [
              _createVNode("div", _hoisted_90, [
                _createVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 2), [
                  [_vModelText, _ctx.state.data.unit.name]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitName)
                  ? (_openBlock(), _createBlock("p", _hoisted_92, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_93, [
                _createVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('abbreviation')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.abbreviation]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                  ? (_openBlock(), _createBlock("p", _hoisted_95, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_96, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.ui.isLoading.addNewSubItem)
      ? (_openBlock(), _createBlock(_component_CreateLineItemInJobEstimation, {
          key: 2,
          onSave: _ctx.saveItem,
          dataFor: _ctx.state.dataFor,
          itemId: _ctx.state.selectItemId
        }, null, 8, ["onSave", "dataFor", "itemId"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_97, [
      _createVNode("div", _hoisted_98, [
        _createVNode("div", _hoisted_99, [
          _createVNode("div", _hoisted_100, [
            _createVNode("div", _hoisted_101, [
              _createVNode("h5", _hoisted_102, _toDisplayString(_ctx.$t('delete_subitem')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.deleteItemClose()))
              }, [
                _hoisted_103
              ])
            ]),
            _createVNode("div", _hoisted_104, [
              _hoisted_105,
              _createVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_107, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.removeSelectedSubItem(_ctx.state.selectDeleteItem)))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}